import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    tovGroupContainer: {
      padding: theme.spacing(2),
    },
    tovGroupWrapper: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: theme.spacing(1.5),
      '& + &': {
        marginTop: theme.spacing(3),
      },
    },
    title: {
      marginBottom: theme.spacing(1.5),
    },
    buttonTrain: {
      display: 'flex',
      marginLeft: 'auto',
      marginBottom: theme.spacing(1.5),
      ...theme.typography.medium12,
    },
    iconMagicWand: {
      // HINT: we need to overcome specificity of ".MuiButton-iconSizeMedium > *:first-child"
      '&&': {
        fontSize: theme.typography.pxToRem(12),
      },
    },
    button: {
      width: ({ isInfinityMode }) => (isInfinityMode ? 190 : 210),
      height: 125,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: COLORS.neutral.white,
      fontFamily: theme.typography.fontFamily,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      padding: theme.spacing(2, 1.5),
      rowGap: theme.spacing(1.5),
      border: theme.shape.borderGray70,
      boxShadow: theme.shape.boxShadowNormal,
    },
    presetDescription: {
      whiteSpace: 'pre-line',
    },
  }),
  { name: 'ToneOfVoiceList' }
);
